import React from 'react';
import { Stripe } from '@capacitor-community/stripe';
import { loadStripe } from '@stripe/stripe-js';

const ApplePayButton = () => {
  const initializeApplePay = async () => {
    try {
      // Initialize Stripe
      const stripe = await loadStripe('pk_live_51MmSEwBKr2QnYiIcxeDTq0CnvClORHfLodBUtzVv3tNgzlfi6boLyOXlzCqfY6SEPTnQx3tjnGr2UBYLrHYuZBOp002rWVMX9I');
      
      // Check if Apple Pay is available
      const isApplePayAvailable = await Stripe.isApplePayAvailable();
      
      if (!isApplePayAvailable) {
        alert('Apple Pay is not available on this device');
        return;
      }

      // Create Apple Pay payment request
      await Stripe.createApplePay({
        paymentRequest: {
          countryCode: 'US',
          currencyCode: 'USD',
          merchantIdentifier: 'your_merchant_id_from_apple',
          supportedNetworks: ['visa', 'mastercard', 'amex'],
          items: [
            {
              label: 'Product Name',
              amount: '10.00'
            }
          ]
        }
      });

      // Present Apple Pay sheet
      const result = await Stripe.presentApplePay();
      
      // Confirm payment with your backend
      const { paymentIntent } = await confirmPaymentWithBackend(result);

      // Finalize the transaction
      await Stripe.completeApplePay({
        paymentIntent: paymentIntent
      });

      alert('Payment successful!');
      
    } catch (error) {
      console.error('Apple Pay error:', error);
      alert('Payment failed: ' + error.message);
    }
  };

  const confirmPaymentWithBackend = async (applePayResult) => {
    // Call your backend to confirm the payment
    // This is where you'd typically make a fetch request to your server
    // to create a PaymentIntent with Stripe
    
    // Example (you'll need to implement your own endpoint):
    const response = await fetch('https://your-backend.com/create-payment-intent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount: 1000, // in cents
        currency: 'usd',
        paymentMethodId: applePayResult.paymentMethod.id
      })
    });
    
    return await response.json();
  };

  return (
    <div>
      <button onClick={initializeApplePay}>Pay with Apple Pay</button>
    </div>
  );
};

export default ApplePayButton;